

//云端环境部署参数
// 本地部署参数

// export const domain = "192.168.1.88:10000";
// export const url = "http://192.168.1.88:10000/";
// export const domain1 = " 192.168.1.88:10001";
// export const url1 = "http://192.168.1.88:10001/";

// export const domain = "192.168.10.55:10000";
// export const url = "http://192.168.10.55:10000/";
// export const domain1 = "192.168.10.55:10001";
// export const url1 = "http://192.168.10.55:10001/";

//本地部署
// export const domain = "192.168.0.139:10000";
// export const url = "http://192.168.0.139:10000/";
// export const domain1 = "192.168.0.139:10001";
// export const url1 = "http://192.168.0.139:10001/";

export const domain = "nmyihua-phm.cn";
export const url = "https://nmyihua-phm.cn/";
export const domain1 = "nmyihua-phm.cn";
export const url1 = "https://nmyihua-phm.cn/";


//远端云服务器
// export const domain = "10.167.2.100:10000";
// export const url = "http://10.167.2.100:10000/";


